<template>
  <div>
    <Head :title="form.title" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/filters">Filters</Link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ form.title }}
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.title" :error="form.errors.title" class="pb-8 pr-6 w-full lg:w-1/2" label="Title" />
          <select-input v-model="form.connector_id" :error="form.errors.connector_id" class="pb-8 pr-6 w-full lg:w-1/2" label="Connector" disabled>
            <option :value="null" />
            <option v-for="connector in connectors" :key="connector.id" :value="connector.id">{{ connector.title }}</option>
          </select-input>
          <div v-for="(input, index) in form.conditions" :key="`condition-${index}`" :error="form.errors.conditions" class="input wrapper w-full -center flex items-center mb-3">
            <div class="h-10 w-1/3 rounded-lg outline-none mr-2">
              <select v-model="input.field" class="form-select">
                <option></option>
                <option v-for="connectorField in connectorFields" :key="connectorField" :value="connectorField">{{ connectorField }}</option>
              </select>
            </div>
            <div class="h-10 w-1/3 rounded-lg outline-none mr-2">
              <select v-model="input.operator" class="form-select">
                <option></option>
                <option v-for="operator in operators" :key="operator" :value="operator">{{ operator }}</option>
              </select>
            </div>
            <text-input v-model="input.value" type="text" class="h-10 w-1/3 rounded-lg outline-none" placeholder=" Enter Value" />
            <icon name="plus" @click="addField(input, form.conditions)" />
            <icon name="remove" v-show="form.conditions.length > 1" @click="removeField(index, form.conditions)" />
          </div>
          <div v-if="conditionsError" class="w-full mb-3 text-center form-error">{{ conditionsError }}</div>
        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <button class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Delete Filter</button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Update Filter</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  components: {
    Head,
    Icon,
    Link,
    LoadingButton,
    TextInput,
    SelectInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    filter: Object,
    connectors: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        title: this.filter.title,
        connector_id: this.filter.connector_id,
        conditions: JSON.parse(this.filter.conditions),
      }),
      operators: ['=', '!=', '>', '>=', '<', '<=', 'CONTAINS', 'NOT CONTAINS'],
      connectorFields: null,
      conditionsError: null,
    }
  },
  mounted() {
    this.connectors.forEach((value, index) => {
      if (value.id == this.form.connector_id) {
        let json = value.mapping_json
        this.connectorFields = Object.keys(JSON.parse(json))
      }
    })
  },
  methods: {
    update() {
      this.form.put(`/filters/${this.filter.id}`)
    },
    destroy() {
      if (confirm('Are you sure you want to delete this filter?')) {
        this.$inertia.delete(`/filters/${this.filter.id}`)
      }
    },
    addField(value, fieldType) {
      this.conditionsError = null
      if (value.field == '' || value.operator == '' || value.value == '') {
        this.conditionsError = 'fields are empty.'
      } else {
        fieldType.push({ field: '', operator: '', value: '' })
      }
    },
    removeField(index, fieldType) {
      fieldType.splice(index, 1)
    },
  },
}
</script>
